(function() { window.GUID_cc1a789c_a0c7_44cf_90e4_7d76e779fade = { getGuid: function() { return "cc1a789c-a0c7-44cf-90e4-7d76e779fade"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FixedHeadersHelper {
            get NbInstances() {
                return this.headerHelpers.length;
            }
            static ActivateFixedHeaderFeature(parameters) {
                if (!CS.Controls.FixedHeadersHelper.Instance) {
                    CS.Controls.FixedHeadersHelper.Instance = new FixedHeadersHelper();
                    CS.DOM.$body.offon('ajaxnavigating.FixedHeaderhelper', function () {
                        // Clean up all header helpers before navigation
                        if (CS.Controls.FixedHeadersHelper.Instance) {
                            CS.Controls.FixedHeadersHelper.Instance.CleanupAllHelpers();
                        }
                    });
                    $(() => {
                        CS.Controls.FixedHeadersHelper.Instance.Start();
                    });
                    //CS.Ajax.AjaxListener.OnAjaxStateChange((state: Ajax.AjaxState) => {
                    //    if (state == Ajax.AjaxState.SmartScriptsExecuted &&
                    //        CS.Controls.FixedHeadersHelper.Instance &&
                    //        CS.Controls.FixedHeadersHelper.Instance.hasChanged) {
                    //        CS.Controls.FixedHeadersHelper.Instance.Start();
                    //    }
                    //});
                }
                CS.Controls.FixedHeadersHelper.Instance.hasChanged = true;
                CS.Controls.FixedHeadersHelper.Instance.onAfterShow = parameters.OnAfterShow;
                let helper = new Controls.FixedHeaderHelper(parameters);
                helper.OnAfterShowFixedHeader = parameters.OnAfterShow;
                this.RemoveHelperFromListIfIdExist(helper);
                CS.Controls.FixedHeadersHelper.Instance.headerHelpers.push(helper);
                CS.Controls.FixedHeadersHelper.Instance.Start();
                return helper;
            }
            CleanupAllHelpers() {
                let me = this;
                for (var i = me.headerHelpers.length - 1; i >= 0; i--) {
                    let fixedHeader = me.headerHelpers[i];
                    fixedHeader.Dispose();
                    me.headerHelpers.splice(i, 1);
                }
            }
            static RemovePopupHeaderHelpers() {
                if (CS.Controls.FixedHeadersHelper.Instance) {
                    for (var i = CS.Controls.FixedHeadersHelper.Instance.headerHelpers.length - 1; i >= 0; i--) {
                        let fixedHeader = CS.Controls.FixedHeadersHelper.Instance.headerHelpers[i];
                        if (fixedHeader.inPopup) {
                            fixedHeader.Dispose();
                            CS.Controls.FixedHeadersHelper.Instance.headerHelpers.splice(i, 1);
                        }
                    }
                }
            }
            static RemoveHelperFromListIfIdExist(newHelper) {
                if (CS.Controls.FixedHeadersHelper.Instance) {
                    for (var i = 0; i < CS.Controls.FixedHeadersHelper.Instance.headerHelpers.length; i++) {
                        let fixedHeader = CS.Controls.FixedHeadersHelper.Instance.headerHelpers[i];
                        let id = fixedHeader.Id;
                        if (id == newHelper.Id) {
                            fixedHeader.Dispose();
                            CS.Controls.FixedHeadersHelper.Instance.headerHelpers.splice(i, 1);
                            break;
                        }
                    }
                }
            }
            Start() {
                let me = this;
                me.hasChanged = false;
                me.RefreshAllIFixedHeaders();
                CS.DOM.$win.offon('scroll.fixedheadershelper', function () {
                    me.refreshFixedHeadersVisibilities();
                });
                let inPopup = me.headerHelpers.some(helper => helper.inPopup);
                if (inPopup) {
                    $('.popup-content').offon('scroll.fixedheadershelper', function () {
                        me.refreshFixedHeadersVisibilities();
                    });
                }
            }
            constructor() {
                let me = this;
                me.headerHelpers = new Array();
            }
            RefreshAllIFixedHeaders() {
                let me = this;
                CS.Lag('refreshallifixedheaders', 0, function () {
                    requestAnimationFrame(function () {
                        for (var i = 0; i < me.headerHelpers.length; i++) {
                            let helper = me.headerHelpers[i];
                            helper.PreCalculateLayoutForFixedHeaderPositionning();
                        }
                        me.refreshFixedHeadersVisibilities();
                    });
                });
            }
            refreshFixedHeadersVisibilities() {
                let me = this;
                let topBarHeight = null;
                requestAnimationFrame(function () {
                    let $customTopBar = null;
                    let inPopup = me.headerHelpers.some(helper => helper.inPopup);
                    for (var i = 0; i < me.headerHelpers.length; i++) {
                        if (me.headerHelpers[i].$topBar && me.headerHelpers[i].$topBar.length > 0) {
                            $customTopBar = me.headerHelpers[i].$topBar;
                            break;
                        }
                    }
                    if (!topBarHeight) {
                        if ($customTopBar) {
                            topBarHeight = $customTopBar[0].getBoundingClientRect().height;
                        }
                        else {
                            let $sectionTop = $('.section-top');
                            if ($sectionTop.length > 0) {
                                topBarHeight = $('.section-top').last()[0].getBoundingClientRect().height;
                            }
                            let $innerSubTop = $('.section-inner-subtop-content');
                            if ($innerSubTop.length > 0) {
                                topBarHeight += $innerSubTop.last()[0].getBoundingClientRect().height;
                            }
                        }
                    }
                    let vertWinScroll = inPopup ? $('.popup-content').scrollTop() : CS.DOM.$win.scrollTop();
                    var top = vertWinScroll + topBarHeight;
                    if (CS.DOM.$sectionBottom && CS.DOM.$sectionBottom.length > 0) {
                        //var bottom = CS.DOM.$sectionBottom.offset().top;
                        //sectionBottom offset top etait parfois a zero, cest pourquoi jai adopté une autre facon de trouver le bottom
                        let bottom = vertWinScroll + CS.DOM.$win.outerHeight() - CS.DOM.$sectionBottom.outerHeight();
                        let currentHeaderTop = topBarHeight;
                        for (var i = 0; i < me.headerHelpers.length; i++) {
                            let helper = me.headerHelpers[i];
                            let stickyParentHeight = me.getHeightOfStickyParents(helper.$headerRef);
                            let offset = helper.AnalyseCurrentState(top, bottom, currentHeaderTop + stickyParentHeight);
                            currentHeaderTop += offset;
                            top += offset;
                        }
                    }
                });
            }
            getHeightOfStickyParents($header) {
                let me = this;
                let $stickyParent = $header.parents('.accordion-container');
                let sectionTopHeight = 0;
                sectionTopHeight = 0;
                if ($stickyParent.length > 0) {
                    $.each($stickyParent, (e, element) => {
                        let $this = $(element);
                        let $childs = $this.find('.sticky');
                        $.each($childs, (s, sele) => {
                            sectionTopHeight += sele.getBoundingClientRect().height;
                        });
                    });
                }
                return sectionTopHeight;
            }
        }
        Controls.FixedHeadersHelper = FixedHeadersHelper;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=fixed-headers-helper.pre.js.map
